import { DarkModeContext, ThemeType } from "helpers/theme"
import { useContext } from "react"

export const useTheme = (): ThemeType => {
    const theme = useContext(DarkModeContext)
    return theme
}
